export const busAdminNameKey = "name";
export const dataSaved = "data";
export const busAdminTokenKey = "public_key";
export const BASE_URI = "https://publicbus-dev-api.liyubus.com";
